module.exports = __webpack_public_path__ + "static/media/vintage-flare-dress.684af176.jpg";